module.exports = __webpack_public_path__ + "static/media/closeX.743db469.svg";